import React, { useEffect, useState } from "react";
import {
  IoIosArrowRoundBack,
  IoIosArrowRoundForward,
  IoIosPersonAdd,
} from "react-icons/io";
import { RotatingLines } from "react-loader-spinner";
import { Link } from "react-router-dom";
import CustomerCreditList from "../../Transactions/CustomerCreditList";
import StaffCreditList from "../../Transactions/StaffCreditList";
import ProtocolCreditList from "../../Transactions/ProtocolCreditList";

const PrintCreditSales = () => {
    const [activeTab, setActiveTab] = useState(1)
  
  return (
    <div className="p-[20px]">
      <div className="py-[32px] flex items-center gap-3">
        <IoIosPersonAdd className="text-[19px]" />
        <h4 className="text-[19px]">
          <b>Credit</b> - Repayments
        </h4>
      </div>
      <div className="border border-[#ddd] bg-white">
        <div className="p-[20px]">
          <h5 className="my-[2px] text-[17px]">Unsettled credit</h5>
        </div>
        <div className="p-[20px]">
          <ul className="flex">
            <li
              onClick={() => setActiveTab(1)}
              className={`${
                activeTab === 1
                  ? "border-t-2 border-t-[#2196F3] border-x border-slate-400"
                  : "text-[#888] hover:text-black cursor-pointer"
              }  text-[13px] py-[9px] px-[15px]`}
            >
              Customers
            </li>
            <li
              onClick={() => setActiveTab(2)}
              className={`${
                activeTab === 2
                  ? "border-t-2 border-t-[#2196F3] border-x border-slate-400"
                  : "text-[#888] hover:text-black cursor-pointer"
              }  text-[13px] py-[9px] px-[15px]`}
            >
              Staff
            </li>
            <li
              onClick={() => setActiveTab(3)}
              className={`${
                activeTab === 3
                  ? "border-t-2 border-t-[#2196F3] border-x border-slate-400"
                  : "text-[#888] hover:text-black cursor-pointer"
              }  text-[13px] py-[9px] px-[15px]`}
            >
              Protocol
            </li>
          </ul>
          {activeTab === 1 && (
            <CustomerCreditList />
          )}

          {activeTab === 2 && (
            <StaffCreditList
             />
          )}

          {activeTab === 3 && (
            <ProtocolCreditList />
          )}
        </div>
        
      </div>
    </div>
  );
};

export default PrintCreditSales;
